export default {
  state: {
    dropzone: {
      show: false,
      items: [],
      checkRoute: false,
      drivers: [],
      saveSuccess: false
    }
  },
  mutations: {
    setDropzoneShow (state, value) { state.dropzone.show = value },
    setDropzoneItems (state, value) { state.dropzone.items = value },
    addDropzoneItem (state, value) {
      if (value.type === 'rsvp') {
        state.dropzone.items.push(value.legs[0])
        state.dropzone.items.push(value.legs[1])
        return
      }

      for (let i = 0; i < value.legs.length; i++) {
        state.dropzone.items.push(value.legs[i])
      }
    },
    updateDropzoneEta (state, value) {
      let leg = value.leg
      let eta = value.eta
      let index = state.dropzone.items.findIndex((item, index, self) => {
        return item.reservationID === leg.reservationID &&
        item.packageID === leg.packageID &&
        item.isPickup === leg.isPickup
      })
      if (index > 0) {
        state.dropzone.items[index].eta = eta
      }
    },
    removeDropzoneItem (state, value) {
      let items = state.dropzone.items
      state.dropzone.items = items.filter( item => item.reservationID !== value.reservationID )
    },
    removeDropzoneItems (state, value) {
      let items = state.dropzone.items
      if (value.type === 'rsvp') {
        state.dropzone.items = items.filter(item => item.reservationID !== value.id)
        return
      }
      state.dropzone.items = items.filter(item => item.packageID !== value.id)
    },
    clearDropzone (state) {
      state.dropzone.show = false
      state.dropzone.items = []
      state.dropzone.checkRoute = false
      state.dropzone.drivers = []
    },

    // Loading states
    setCheckRouteLoading (state, value) { state.dropzone.checkRoute = value },

    // driver states
    setDropzoneDrivers (state, value) { state.dropzone.drivers = value},
    removeDropzoneDrivers (state) { state.dropzone.drivers = [] },
    addDropzoneDriver (state, value) { state.dropzone.drivers.push(value) },
    removeDropzoneDriver (state, value) {
      let items = state.dropzone.drivers
      state.dropzone.drivers = items.filter(item => item.packageID !== value.packageID || item.driver.id !== value.driver.id)
    },
    removeDropzonePackageDriver (state, packageID) {
      let items = state.dropzone.drivers
      state.dropzone.drivers = items.filter(item => item.packageID !== packageID)
    },
    setDropzoneSaveSuccess (state, value) { state.dropzone.saveSuccess = value },
  }
}



// WEBPACK FOOTER //
// ./src/store/laxit/dropzone.js